import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Required from './Required';
import styles from './RadioButtonGroup.css';

class RadioButtonGroup extends PureComponent {
  handleChange = event => {
    this.props.input.onChange(event.currentTarget.value);
  };
  render() {
    const { label, helpText, options, required, input, meta, ...rest } = this.props;
    const hasError = meta.touched && !!meta.error;
    const Wrapper = label ? 'label' : React.Fragment;

    return (
      <Wrapper {...(label ? { className: styles.label } : {})}>
        {label && (
          <>
            <span className={cx({ [styles.error]: hasError })}>{label}</span>
            {helpText && <span className={styles.helpText}>{helpText}</span>}
            {required && <Required />}
          </>
        )}
        <br />
        <div>
          {options.map(option => (
            <label className={styles.option} key={option.value}>
              <input
                className={styles.radioButton}
                type="radio"
                name={input.name}
                value={option.value}
                checked={option.value === input.value}
                onChange={this.handleChange}
              />{' '}
              {option.label}
            </label>
          ))}
        </div>
      </Wrapper>
    );
  }
}

RadioButtonGroup.propTypes = {
  label: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  helpText: PropTypes.any,
  required: PropTypes.bool,
};

export default RadioButtonGroup;
